"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * @deprecated
 */
exports.Detail = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100% - 30px);\n  margin: 30px 30px 0;\n"], ["\n  height: calc(100% - 30px);\n  margin: 30px 30px 0;\n"])));
var templateObject_1;
